import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { BackendPage } from '../../app';

export const AccountingConfigurationPage = () => {
    const resolveRoute = useResolveRoute();
    const enterpriseId = useCurrentEnterpriseId();

    const accountingConfigurationBackendUrl = resolveRoute(RouteName.AccountingConfigurationDetail, {
        enterpriseId,
    });

    return (
        <BackendPage
            loadingOverlayFixed
            absolutePosition={false}
            layout="EmptyDialog"
            url={accountingConfigurationBackendUrl}
            withUnsavedChangesDialog
        />
    );
};
